"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _Tab = _interopRequireDefault(require("../common/Tab/Tab"));
var _MarginBalances = require("../MarginBalances");
var _InstrumentPositionsContainer = _interopRequireDefault(require("../InstrumentPositions/InstrumentPositionsContainer"));
var _FuturesContractDetails = _interopRequireDefault(require("../FuturesContractDetails"));
var _FuturesAccountOverview = _interopRequireDefault(require("../FuturesAccountOverview"));
require("./InstrumentPositionsTabsComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('instrument-positions-tabs');
var InstrumentPositionsTabsComponent = function InstrumentPositionsTabsComponent(_ref) {
  var isMarginActive = _ref.isMarginActive,
    isFuturesActive = _ref.isFuturesActive;
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var _getPanes = function _getPanes() {
    return [isMarginActive && {
      menuItem: t('Margin Overview'),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(_MarginBalances.MarginOverviewContainer, {
          showTitle: false
        });
      }
    }, isFuturesActive && {
      menuItem: t('Contract Details'),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(_FuturesContractDetails["default"], {
          showTitle: false
        });
      }
    }, isFuturesActive && {
      menuItem: t('Account Overview'),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(_FuturesAccountOverview["default"], {
          showTitle: false
        });
      }
    }, !isFuturesActive && {
      menuItem: t('Balances'),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(_InstrumentPositionsContainer["default"], {
          showTitle: false
        });
      }
    }].filter(Boolean);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
    panes: _getPanes(),
    customClass: baseClasses()
  }));
};
InstrumentPositionsTabsComponent.defaultProps = {
  isMarginActive: false,
  isFuturesActive: false
};
InstrumentPositionsTabsComponent.propTypes = {
  isMarginActive: _propTypes["default"].bool,
  isFuturesActive: _propTypes["default"].bool
};
var _default = exports["default"] = InstrumentPositionsTabsComponent;